import React from 'react';
export const Quotes = () => {
  return <div className="py-16 bg-gray-50 relative" data-id="element-125">
      {/* Subtle background element */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-5 pointer-events-none" data-id="element-126">
        <div className="w-full h-full bg-repeat" style={{
        backgroundImage: "url('https://www.transparenttextures.com/patterns/subtle-dots.png')"
      }} data-id="element-127"></div>
      </div>
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-128">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 flex items-center" data-id="element-129">
          <span className="text-red-700 mr-2" data-id="element-130">★</span>
          Voices from the aftermath
        </h2>
        <p className="text-lg text-gray-700 mb-8" data-id="element-131">
          This book amplifies the voices that matter most: survivors, families,
          and first responders who lived through these tragedies:
        </p>
        <div className="grid gap-6 md:grid-cols-1 mb-12" data-id="element-132">
          <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-red-700" data-id="element-133">
            <blockquote className="text-xl italic font-medium text-gray-800 mb-4" data-id="element-134">
              "I heard the shots and hid in the closet. I texted my mom 'I love
              you' because I thought it would be the last thing I'd ever say to
              her."
            </blockquote>
            <p className="text-right text-gray-600" data-id="element-135">— Parkland survivor, 16</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-gray-700" data-id="element-136">
            <blockquote className="text-xl italic font-medium text-gray-800 mb-4" data-id="element-137">
              "My daughter was more than a statistic. She had dreams, friends, a
              future. All gone in seconds because of our collective failure to
              act."
            </blockquote>
            <p className="text-right text-gray-600" data-id="element-138">
              — Parent of Sandy Hook victim
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-red-700" data-id="element-139">
            <blockquote className="text-xl italic font-medium text-gray-800 mb-4" data-id="element-140">
              "The warning signs were there. We reported them. The system failed
              these kids, and now they're gone."
            </blockquote>
            <p className="text-right text-gray-600" data-id="element-141">
              — School counselor, Uvalde
            </p>
          </div>
        </div>
        <p className="text-lg text-gray-700 font-medium text-center" data-id="element-142">
          These testimonies are not just stories—they're calls to action that
          demand our response.
        </p>
      </div>
    </div>;
};